import {nextTick} from "vue";

export function triggerUpgrade(store, type) {
    store.commit('showNeedUpgrade', type);

    nextTick(() => {
        store.commit('showNeedUpgrade', false)
    });
}
